import React, { FC } from "react";
import NewLayout from "../../components/new-ui/Layout";
import HeaderImage from "../../components/CaseStudyComponents/HeaderImage";
import Aside from "../../components/CaseStudyComponents/Aside";
import About from "../../components/CaseStudyComponents/About";
import Challenge from "../../components/CaseStudyComponents/Challenge";
import Solution from "../../components/CaseStudyComponents/Solution";
import Impact from "../../components/CaseStudyComponents/Impact";
import RelatedCaseStudies from "../../components/CaseStudyComponents/RelatedCaseStudies";
import ImageComponent from "../../components/CaseStudyComponents/ImageComponent";
import Signup from "../../components/CaseStudyComponents/Signup";
import Quote from "../../components/CaseStudyComponents/Quote";
import AchievementCard from "../../components/CaseStudyComponents/AchievementCard";

const SattvicStore: FC = () => {
    const cardData = [
        {
            imgpath: "https://assets.gallabox.com/gb-home/case-study/cart.png",
            title: "Reduction",
            count: "10%",
            by: "in RTO",
            borderColor: "#ACDAF1",
            boxShadowColor: "#D4ECF8",
            fontColor: "#3B7D9E",
            gradient: "linear-gradient(105.67deg, rgba(215, 235, 245, 0.2) 0%, #D7EBF5 95.66%)",
        },
        {
            imgpath: "https://assets.gallabox.com/gb-home/case-study/arrowdown.png",
            title: "Reduction",
            count: "30%",
            by: "in Marketing Cost ",
            borderColor: "#C9E6AD",
            boxShadowColor: "#ECF8E1",
            fontColor: "#72A649",
            gradient: "linear-gradient(285.78deg, #ECF8E1 3.17%, rgba(236, 248, 225, 0.2) 96.84%)",
        },
        {
            imgpath: "https://assets.gallabox.com/gb-home/case-study/Roboface.png",
            title: "Chats handled",
            count: "2x",
            by: "by Bot ",
            borderColor: "#DEBEF3",
            boxShadowColor: "#EFE1F8",
            fontColor: "#9461B5",
            gradient: "linear-gradient(285.94deg, #EFE1F8 1.79%, rgba(239, 225, 248, 0.2) 98.89%)",
        },
    ];
    const RELATED_CASE_STUDIES = [
        {
            id: 1,
            bannerimg: "https://assets.gallabox.com/gb-home/case-study/case-study-banner-1.png",
            tag: "Travel & Tourism",
            title: "LivingStone Stays Relocated Their Communications From..",
            link: "/case-study/livingstone-stay",
            description:
                "Founded in 2019, LivingStone Stays is revolutionising the way people spend their leisure time - making holidays a way of life. Their platform is a one-stop ...",
        },
        {
            id: 2,
            bannerimg: "https://assets.gallabox.com/gb-home/case-study/case-study-banner-3.png",
            tag: "HR & Professional Service",
            title: "Jobstars India Deployed a Multilingual Chatbot to Handle 60%..",
            link: "/case-study/jobstars-india",
            description:
                "Founded in 2002, Jobstars is one of the leading players in the Indian recruitment ecosystem. They believe in combining their passion for people with smart investments ...",
        },
    ];

    return (
        <NewLayout
            title="Sattvic Stores - Case Study | Gallabox"
            description="Sattvic Stores Reduced RTO by 10% within a month of using Gallabox’s WhatsApp Broadcast Feature"
            canonical="https://gallabox.com/case-study/sattvic-store"
        >
            <HeaderImage
                imagePath={"https://assets.gallabox.com/gb-home/case-study/sattvicheadimg.png"}
                imageText={"Sattvic Stores Reduced RTO by 10% within a month of using Gallabox’s WhatsApp Broadcast Feature"}
            />
            <div className="max-w-md  sm:max-w-max mx-auto px-5 sm:px-10 lg:px-32 mt-20">
                <section className="max-w-6xl mx-auto flex flex-col items-center sm:flex-row gap-5 my-20 justify-between ">
                    {cardData.map((eachobj) => {
                        return (
                            <AchievementCard
                                key={""}
                                imagePath={eachobj.imgpath}
                                imageTitle={eachobj.title}
                                count={eachobj.count}
                                by={eachobj.by}
                                borderColor={eachobj.borderColor}
                                boxShadowColor={eachobj.boxShadowColor}
                                fontColor={eachobj.fontColor}
                                gradient={eachobj.gradient}
                            />
                        );
                    })}
                </section>
                <div className="max-w-6xl mx-auto flex flex-col sm:flex-row gap-8">
                    <div className="basis-1/5 mx-auto ">
                        <Aside
                            data={[
                                {
                                    title: "Company",
                                    content: "Sattvic Store",
                                },
                                {
                                    title: "Industry",
                                    content: "Retail, D2C",
                                },
                                {
                                    title: "Employees",
                                    content: "15-20",
                                },
                                {
                                    title: "Product used",
                                    content: ["Standard Chatbot", "Google Sheet", "Integration", "WhatsApp Broadcast", "Shared Team Inbox"],
                                },
                                {
                                    title: "Chats per Month",
                                    content: "5k+",
                                },
                                {
                                    title: "Website",
                                    link: "www.sattvicstore.com",
                                    content: "sattvicstore.com",
                                },
                            ]}
                        />
                    </div>
                    <main className="basis-4/5">
                        <About
                            aboutLogo={"https://assets.gallabox.com/gb-home/case-study/sattviclogo.png"}
                            aboutTitle={"Sattvic Stores"}
                            aboutContent={`Sattvic Stores by Kabir Innovations is an online retail 
                            marketplace selling organic health supplements, herbs,
                            extracts, and more. They locally source their products from rural startups and women entrepreneurs, guaranteeing the 
                            best of quality- #purity ki #assurity
                            `}
                        />
                        <Challenge
                            challengeTitle={"25% RTO, Traditional manual agent support and marketing services"}
                            challengeList={[
                                "High marketing budgets to reach a wider audience for every campaign.",
                                "25% of orders were returned due to products not suiting the client or ordering the wrong products.",
                                "Manual efforts were taken to engage existing customers with new product launches.",
                                "Their support services were of traditional methods i.e., calling and messaging. No WhatsApp automation, only manual agent intervention.",
                                "Niche segments were identified but the execution of marketing efforts was limited.",
                            ]}
                        />
                        <ImageComponent caption={""} imagelink={"https://assets.gallabox.com/gb-home/case-study/sattvicimg.png"} />
                        <Solution
                            solutionTitle={" A WhatsApp Chatbot was employed to reduce RTO. Shared inbox & broadcast features managed upselling and cross-selling of products"}
                            solutionContent={""}
                            solutionData={[
                                "Created a WhatsApp chatbot to reduce RTO by counselling clients on their specific requirements.",
                                "Client data collected by the bot was directed to one common database that could be accessed by all members of the store.",
                                "Upselling of Customer Specific Products - Created a support service through WhatsApp chatbots to aid clients in the buying process and any product related queries. This also created an opportunity to sell products suited to the customer’s needs and reduced returning orders.",
                                "Cross-selling to a Niche of Customers - Created advanced customer segments through tagging/labelling of contacts to WhatsApp broadcast their new arrivals and customer-specific products.",
                            ]}
                        />
                        <Quote
                            quoteText={"Gallabox not only nurtures your clients but also reduces RTO by sending instant updates. 101% satisfied with the tool!"}
                            quoteBy={"- Mr. Vinod,"}
                            position={"for Kabir Innovations - Sattvic Stores"}
                            paddingx={"px-7 sm:px-10 lg:px-16"}
                        />
                        <Impact
                            impactContent={[
                                `<li class="content">
                                Gallabox helped reduce Sattvic Store’s RTO by  <span class="text-blue-color">10%</span>within 30 days.
                    </li>`,
                                `<li class="content">
                                WhatsApp broadcast segments through labelling of contacts reduced their marketing budgets by <span class="text-blue-color">30%</span> 
                </li>`,
                                `<li class="content">
                Satvic Stores acquired 2000+ customers within 2 months with the help of Gallabox's Chatbot which <span class="text-blue-color">saved 10,000 minutes</span>of
                human intervention.
            </li>`,
                                ` <li class="content">
                                Support chatbot reduced manual agent efforts by<span class="text-blue-color">50%.</span> 
                                To summarise traditional messaging practices in the current digital environment for e-commerce businesses aren't the best fit. To avoid returning orders, brands like Sattvic Store employ 24x7 support chatbots to automate their operations and reduce their RTO thereby increasing their ROI. 
        </li>`,
                            ]}
                        />
                    </main>
                </div>
            </div>
            <Signup img="https://assets.gallabox.com/gb-home/case-study/Robot.png" content="Want similar results?" btn="Sign Up For A Free Trial" />
            <RelatedCaseStudies sectionDescription="Related Case Studies" related={RELATED_CASE_STUDIES} />
        </NewLayout>
    );
};

export default SattvicStore;
